/**
 * Entry point del portale paziente (bundle dist/paziente).
 *
 * VINCOLI INVIOLABILI PR4:
 *  - NESSUN import di `firebase/auth`
 *  - NESSUN import da `@app/*`
 *  - NESSUN init di Auth o sessione utente
 *  - Cloud Functions sono chiamate "no auth", protette da UUID
 *    token + rate limiting Firestore (vedi functions/src/onboarding/).
 *
 * AppCheck e' inizializzato per garantire che le richieste alle CF
 * provengano da un client legittimo (defense-in-depth contro
 * scripted abuse del flusso onboarding).
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './firebase-paziente';
import { initPazienteAppCheck } from './firebase-paziente';
import { PazienteApp } from './PazienteApp';

initPazienteAppCheck();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PazienteApp />
  </StrictMode>
);
